///<reference path='../../core/services/guid.service.ts'/>
'use strict';

angular
    .module('TR')
    .directive('tokenisingField', ($timeout,
                                   $window: ng.IWindowService,
                                    $parse: ng.IParseService,
                                    $q: ng.IQService,
                                    guidService: Core.GuidService,
                                    tokeniser: any,
                                    $rootScope: ng.IRootScopeService,
                                    broker: any): ng.IDirective => {
        return {
            replace: true,
            require: 'ngModel',
            scope: {
                model: '=ngModel',
                tokenErrors: '=',
                focusTracker: '=', // Ref to field ngModelController
                cls: '@',
                rootForm: '=',
                placeholder: '@',
                invalidMsg: '@',
                requiredMsg: '@',
                fieldType: '@',
                validateAs: '@',
                alwaysShowErrors: '=',
                maskModel: '=',
                manual:'=',
                onMask:'&',
                instantValidation: '='
            },
            templateUrl: (el :ng.IAugmentedJQuery, attr) => {
                if ( attr.templateVersion ){
                    return 'partials/booking/template?name=TokeniserFrame&version=' + attr.templateVersion;
                }
                return 'partials/home/directivetemplate?type=TokeniserFrame';
            },
            link: function($scope: ng.IScope,
                           el: ng.IAugmentedJQuery,
                           attr: any, controller: ng.INgModelController) {
                const placeholder = attr.placeholder,
                    fieldType = attr.fieldType,
                    validateAs = attr.validateAs,
                    clientId = guidService.uuid();
                let frame,
                    deferred;

                if($scope['manual']) {
                    //if we're in manual mode, we need to register a tokenise function
                    $scope.$on('$destroy', tokeniser.register((expiry) => {
                        deferred = $q.defer();
                        postMessage({
                            type: 'gettoken',
                            expiry
                        });
                        return deferred.promise;
                    }));
                }

                function parseMessage(ev) {
                    try {
                        return JSON.parse(ev.data);
                    }
                    catch(err) {
                        return {};
                    }
                }
                function receiveMessage(ev){
                    const msg = parseMessage(ev);
                    if(msg.clientId === clientId) {
                        switch(msg.type) {
                            case 'blur':
                                // Can't use `$scope.$parent.ft` as overwritten each time
                                $scope['focusTracker'].ft.blurHandler();
                                broker.publish('pciFrameBlur');
                                break;
                            case 'focus':
                                $scope['focusTracker'].ft.focusHandler();
                                broker.publish('pciFrameFocus');
                                break;
                            case 'mask' :
                                $scope.$evalAsync(() => {
                                    $scope['tokenErrors'] = null;
                                    $scope['maskModel'] = msg.mask;
                                    if($scope['onMask']) {
                                        $timeout(() => {
                                            $scope['onMask']();
                                        }, 0);
                                    }
                                });
                                break;
                            case 'token':
                                $scope.$evalAsync(() => {
                                    $scope['tokenErrors'] = null;
                                    controller.$setViewValue(msg.token);
                                    if(msg.mask) {
                                        $scope['maskModel'] = msg.mask;
                                    }
                                    if(deferred) {
                                        deferred.resolve();
                                    }
                                });
                                break;
                            case 'error':
                                $scope.$evalAsync(() => {
                                    $scope['tokenErrors'] = msg.errors;
                                    controller.$setViewValue(null);
                                    $scope['maskModel'] = msg.mask;
                                    if(deferred) {
                                        deferred.resolve();
                                    }
                                });
                                break;
                        }
                    }
                }

                function postMessage(msg) {
                    msg.clientId = clientId;
                    frame.contentWindow.postMessage(JSON.stringify(msg), '*');
                }

                frame = $('iframe', el).on('load', () => {
                    postMessage({
                        type: 'init',
                        fieldType,
                        manual: $scope['manual'],
                        validateAs,
                        placeholder,
                        rtl: TRPCONFIG.Rtl,
                        style: {
                            fontSize: '14px'
                        }
                    });
                })[0];
                $window.addEventListener('message', receiveMessage);

                $scope.$on('$destroy', () => {
                    $window.removeEventListener('message', receiveMessage);
                });

                $scope['getToken'] = () => {
                    postMessage({
                        type: 'requestToken'
                    });
                };

                //hideous hack to deal with the fact that angular sucks
                $scope.$watch('model', function() {
                    $scope.$eval(attr.ngModel + ' = model');
                });
                $scope.$watch(attr.ngModel, function(val) {
                    $scope['model'] = val;
                });
                $scope['showErrors'] = () => {
                    return $scope['tokenErrors'] != null &&
                        (($scope['focusTracker'] &&
                        $scope['focusTracker']['focused']) || $scope['alwaysShowErrors']) &&
                        ($rootScope['submittedForm'] === $scope['rootForm'] && !$scope['rootForm'].$valid) ||
                        ($scope['tokenErrors'] != null && $scope['focusTracker']['focused'] === false &&
                        $scope.instantValidation) ;
                };

                $scope['showSuccess'] = () => {
                    return ($scope['tokenErrors'] == null && $scope.instantValidation) ;
                };
            }
        };
    });

